import type { GetTweets200PageAllOfThreeContentItem } from './getTweets200PageAllOfThreeContentItem';

export type GetTweets200PageAllOfThree = {
  content?: GetTweets200PageAllOfThreeContentItem[];
};
